import { hasValue } from './lib';

export default class ApiError extends Error {
	constructor(response: Response, body: any) {
		super(hasValue(response.statusText) ? response.statusText : body);
		Object.setPrototypeOf(this, ApiError.prototype);
		this.status = response.status;
		this.statusText = response.statusText;
		this.body = body;
	}

	status: number;

	statusText: string;

	body: any;
}

export const isApiError = (error: unknown): error is ApiError =>
	typeof error === 'object' && error !== null && 'status' in error;

export const getApiErrorMessage = (e: ApiError): string => {
	if (e.body) return e.body;
	if (e.statusText) return e.statusText;
	return e.status === 500 ? 'Internal Server Error' : `Unknown Error: ${e.status}`;
};
